// extracted by mini-css-extract-plugin
export default {"countdown":"countdown_countdown__Kyt+X","datetime":"countdown_datetime__8O2+T"};